import { isNative } from './is';

// For emitting events in NewRelic relating to how frequently a feature is used or an action is taken
export const logMobileUsage = (eventName, attributes = null) => {
    if (isNative()) {
        import('@newrelic/newrelic-capacitor-plugin').then((module) => {
            module.NewRelicCapacitorPlugin.recordCustomEvent({
                eventType: 'mobileUsage',
                eventName: eventName,
                attributes: attributes ?? {}
            });
        });
    }
};
